exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".go-uranaitv-base[data-v-de9e6068]{width:100%;max-width:580px;margin:0 auto}.go-uranaitv-base h3[data-v-de9e6068]{font-weight:700;font-size:26px;line-height:32px;text-align:center;margin:0 0 20px;color:var(--key-color)}.go-uranaitv-base__lower-copy[data-v-de9e6068]{font-size:14px;line-height:21px;text-align:center;margin:20px 0 0;color:#32373f}.go-uranaitv-base .btn-wrap[data-v-de9e6068]{width:100%;max-width:270px;margin:auto}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-de9e6068","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/utvStore/components/recommend/lp/partials/GoUranaiTv.vue
// module id = 10+o
// module chunks = 0 2